import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  LastDealsTableColumn,
  LastDealsTableSorting,
} from '@prlw/core/deals/types/last-deals.types';

@Component({
  selector: 'prlw-last-deals-table-header',
  templateUrl: './last-deals-header.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastDealsHeaderContainer {
  @Input() public column!: LastDealsTableColumn;
  @Input() public sorting: LastDealsTableSorting | null = null;

  public get columnName(): string {
    return this.column.name;
  }

  public get hasSorting(): boolean {
    return this.sorting?.columnId === this.column.id;
  }

  public get isDesSort(): boolean {
    return this.sorting?.direction === 'DESC';
  }
}
